import React from "react"

const Header = ({ siteTitle }) => (
  <header className="bg-transparent" >
  </header>
)
export default Header
